<template>
  <div class="settings--content">
    <settings-section
        :title="$t('AGENT_BOTS.BOT_CONFIGURATION.TITLE')"
        :sub-title="$t('AGENT_BOTS.BOT_CONFIGURATION.DESC')"
      >
        <loading-state v-if="isFetching" />
        <form
            v-else
            class="mx-0 flex flex-wrap"
            @submit.prevent="updateActiveAgentBot"
        >
        <div class="w-[60%]">
          <label>
            <select v-model="selectedAgentBotId">
              <option value="" disabled selected>
                {{ $t('AGENT_BOTS.BOT_CONFIGURATION.SELECT_PLACEHOLDER') }}
              </option>
              <option
                v-for="agentBot in agentBots"
                :key="agentBot.id"
                :value="agentBot.id"
              >
                {{ agentBot.name }}
              </option>
            </select>
          </label>
          <div class="button-container">
            <woot-submit-button
              :button-text="$t('AGENT_BOTS.BOT_CONFIGURATION.SUBMIT')"
              :loading="uiFlags.isSettingAgentBot"
            />
            <woot-button
              type="button"
              :disabled="!selectedAgentBotId"
              :loading="uiFlags.isDisconnecting"
              variant="smooth"
              color-scheme="alert"
              class="button--disconnect"
              @click="disconnectBot"
            >
              {{ $t('AGENT_BOTS.BOT_CONFIGURATION.DISCONNECT') }}
            </woot-button>
          </div>
        </div>
        </form>
      </settings-section>
    <settings-section
        :title="$t('AGENT_BOTS.BOT_CONFIGURATION.BOT_SNOOZE.LABEL')"
        :sub-title="$t('AGENT_BOTS.BOT_CONFIGURATION.BOT_SNOOZE.HELP_TEXT')"
    >
      <loading-state v-if="false" />
      <form
          v-else
          class="mx-0 flex flex-wrap"
          @submit.prevent="updateBotResolvedSnooze"
      >
        <div class="w-[60%]">
          <woot-input
              v-model.trim="botResolvedSnooze"
              type="number"
              class=""
              :placeholder="
            $t('AGENT_BOTS.BOT_CONFIGURATION.BOT_SNOOZE.PLACEHOLDER')
          "
          />
          <div class="button-container pt-4">
            <woot-submit-button
                :button-text="$t('AGENT_BOTS.BOT_CONFIGURATION.SUBMIT')"
                :loading="uiFlags.isSettingBotResolvedSnooze"
            />
          </div>
        </div>
      </form>
    </settings-section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';
import alertMixin from 'shared/mixins/alertMixin';
import botsAPI from "../../../../../api/agentBots";
import {throwErrorMessage} from "../../../../../store/utils/api";

export default {
  components: {
    LoadingState,
    SettingsSection,
  },
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedAgentBotId: null,
      botResolvedSnooze: null,
      agentBots: [],
      isFetching: false,
      isSettingAgentBot: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'agentBots/getUIFlags',
    }),
    activeAgentBot() {
      return this.$store.getters['agentBots/getActiveAgentBot'](this.inbox.id);
    },
  },
  watch: {
    activeAgentBot() {
      this.selectedAgentBotId =  this.activeAgentBot?.bot_type === 'studio' 
          ? this.activeAgentBot.outgoing_url
          : null;
    },
  },
  async mounted() {
    this.load();
    this.$store.dispatch('agentBots/get');
    this.$store.dispatch('agentBots/fetchAgentBotInbox', this.inbox.id)
  },

  methods: {
    async load() {
      this.botResolvedSnooze = this.inbox.bot_resolved_snooze;
      this.isFetching = true;
      try {
          const { data } = await botsAPI.getStudioBots();
          this.agentBots = data.map((bot) => ({
              id: `/bots/${bot.id}/`,
              name: bot.name,
          }));
          
         // commit(types.ADD_AGENT_BOT, data);
      } catch (error) {
          throwErrorMessage(error);
      } finally {
          this.isFetching = false;
      }
      // await this.$store.dispatch('agentBots/get');
      //await this.$store.dispatch('agentBots/fetchAgentBotInbox', this.inbox.id);
    },
    async updateActiveAgentBot() {
      try {
        await this.$store.dispatch('agentBots/setAgentBotInbox', {
          inboxId: this.inbox.id,
          bot: this.selectedAgentBotId ? {
            outgoing_url: this.selectedAgentBotId,
            name: 'Studio Bot',
            bot_type: 'studio',
          } : undefined,
        });
        this.showAlert(this.$t('AGENT_BOTS.BOT_CONFIGURATION.SUCCESS_MESSAGE'));
        await this.$store.dispatch('agentBots/get');
      } catch (error) {
        this.showAlert(this.$t('AGENT_BOTS.BOT_CONFIGURATION.ERROR_MESSAGE'));
      }
    },
    async disconnectBot() {
      try {
        await this.$store.dispatch('agentBots/disconnectBot', {
          inboxId: this.inbox.id,
        });
        this.showAlert(
          this.$t('AGENT_BOTS.BOT_CONFIGURATION.DISCONNECTED_SUCCESS_MESSAGE')
        );
      } catch (error) {
        this.showAlert(
          error?.message ||
            this.$t('AGENT_BOTS.BOT_CONFIGURATION.DISCONNECTED_ERROR_MESSAGE')
        );
      }
    },
    async updateBotResolvedSnooze() {
      try {
        await this.$store.dispatch('inboxes/updateInbox', {
          id: this.inbox.id,
          bot_resolved_snooze: this.botResolvedSnooze,
        });
        this.showAlert(this.$t('AGENT_BOTS.BOT_CONFIGURATION.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('AGENT_BOTS.BOT_CONFIGURATION.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button--disconnect {
  @apply ml-2;
}
</style>
